/**
 * Direct selector to the schema of a plugin
 */
export const selectPluginSchema = (state, pluginId) => state.getIn(['plugins', pluginId]);
